import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { AuthService } from '@fuse/services/auth/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
    forgotPasswordForm: FormGroup;
    lang = 'sr';

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _authService: AuthService,
        private _router: Router,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            theme: {
                layout: {
                    navbar: {
                        hidden: true
                    },
                    toolbar: {
                        hidden: true
                    },
                    footer: {
                        hidden: true
                    },
                    sidepanel: {
                        hidden: true
                    }
                }
            }
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '5');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    resetPassword(formData): void {
        const data = formData.getRawValue();
        this._authService.resetPassword(data.email);

        this._authService.passwordResetComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                if (response && !response['error']) {
                    this._router.navigate(['/mail-confirm']);
                } else {
                    const validationErrors = response['error'];
                    const formControl = this.forgotPasswordForm.get('email');
                    formControl.setErrors({
                        serverError: validationErrors.error
                    });
                }
            });
    }

    checkServerError(fieldName): any {
        return this.forgotPasswordForm.get(fieldName).errors ? this.forgotPasswordForm.get(fieldName).errors.serverError ?
            this.forgotPasswordForm.get(fieldName).errors.serverError : 'This field is required!' : false;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });

        this.getTranslations();
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
